(function () {
radaEnquiryAddProductMiniController.$inject = ['$rootScope', 'enquiryService'];
    angular
        .module('app.enquiry')
        .component('radaEnquiryAddProductMini', {
            bindings: {
                productSelected: '@',
                addToEnquiryText: '@',
                removeFromEnquiryText: '@',
                sku: '@',
                pageId: '@',
                enquiryId: '@'
            }, // components are limited to isolated scope
            templateUrl: '/client/app/enquiry/enquiry-add-product-mini.html',
            controller: radaEnquiryAddProductMiniController
        });

/* @ngInject */
function radaEnquiryAddProductMiniController($rootScope, enquiryService) {
    var vm = this;
 
    vm.$onInit = function () {
        vm.actionLabel = vm.addToEnquiryText;
        if (vm.productSelected==='product-selected')
        {
            vm.checked =true;
            vm.actionLabel = vm.removeFromEnquiryText;
        }
        else {
            vm.checked =false;
        }
    }

    vm.toggleProduct = function() {
        //Add this product via the service
        if (vm.productSelected ==="product-selected")
        {
            $rootScope.$broadcast('product-removed');

            enquiryService.deleteProduct(vm.enquiryId, vm.sku)
            .then(function(response) {
                vm.productSelected ="";
                vm.checked =false;
                vm.actionLabel = vm.addToEnquiryText;
            });
        }
        else
        {
            $rootScope.$broadcast('product-added');

            enquiryService.addProduct(vm.enquiryId, vm.sku, vm.pageId)
            .then(function(response){
                vm.productSelected ="product-selected";
                vm.checked =true;
                vm.actionLabel = vm.removeFromEnquiryText;
            });
        }
    };

}
})();